import URLResolver from 'core/utils/URLResolver';
import routes from 'edrolo/urlRoutes';

export default new URLResolver(routes);
